"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTableCellLayoutContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useTableCellLayoutContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useTableCellLayoutContextValues_unstable(state) {
    const { avatarSize } = state;
    const avatar = _react.useMemo(()=>({
            size: avatarSize
        }), [
        avatarSize
    ]);
    return {
        avatar
    };
}
